
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { Loader2 } from 'lucide-react';

const AdminProtectedRoute: React.FC = () => {
  const { user, loading, isAdmin, checkAdminStatus } = useAuth();
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  useEffect(() => {
    const verifyAdmin = async () => {
      if (user) {
        await checkAdminStatus();
        setCheckingAdmin(false);
      }
      else if (!loading) {
        setCheckingAdmin(false);
      }
    };

    verifyAdmin();
  }, [user, loading, checkAdminStatus]);
  if (loading || checkingAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-form-blue" />
      </div>
    );
  }

  return user && isAdmin ? <Outlet /> : <Navigate to="/" replace />;
};

export default AdminProtectedRoute;
